const reviewStore = {
    need_response_count: 0,
};

export default reviewStore;
